module.exports = __webpack_public_path__ + "img/10.91b64925.png";